export default {
      id: "chat-open-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#chat-open",
      toString: function () {
        return this.url;
      }
    }